angular.module('nv.singleStudent').component('studentNotesPanel', {
  template: require('.//student-notes-panel.html'),
  bindings: {
    student: '=',
    currentUser: '<',
  },
  controller: 'StudentNotesPanelCtrl',
});
